import { render, staticRenderFns } from "./leftTop.vue?vue&type=template&id=33fc83d3&scoped=true"
import script from "./leftTop.vue?vue&type=script&lang=js"
export * from "./leftTop.vue?vue&type=script&lang=js"
import style0 from "./leftTop.vue?vue&type=style&index=0&id=33fc83d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc83d3",
  null
  
)

export default component.exports